import React, { useContext, useEffect } from 'react'
import PropertyGrid from '../../../../components/PropertyGrid'
import { AppContext } from '../../../../global'
import { RequestState } from '../../../types'
import * as actions from '../store/actions'
import './DetailsSettings.css'
import Date from '../../../../components/Date'
import { useTranslation } from 'react-i18next'
import Boolean from '../../../../components/Boolean'
import Loading from '../../../../components/Loading'

type Props = {
  accountId: string
}

function DetailsSettings(props: Props) {
  const { accountId } = props
  const { state, execute } = useContext(AppContext)
  const { accountDetails, requestState } = state.settings.details
  const { t } = useTranslation(['global', 'settings_details'])

  useEffect(() => {
    execute(actions.loadAccountDetails(accountId))
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accountId])

  switch (requestState) {
    case RequestState.NotLoaded:
    case RequestState.Loading: {
      return (       
        <Loading />
      )
    }

    case RequestState.Loaded: {
      return (
        <>
          <table id="details-table" className="content-table" cellSpacing={0} cellPadding={0}>         
            <tbody>
              <tr>
                <td className="first-col">{t('settings_details:name')}</td>
                <td data-cy="name">{accountDetails.name}</td>
              </tr>
              <tr>
                <td>{t('settings_details:country')}</td>
                <td data-cy="country">{accountDetails.country}</td>
              </tr>
              <tr>
                <td>{t('settings_details:currency')}</td>
                <td data-cy="currency">{accountDetails.currency}</td>
              </tr>
              <tr>
                <td>{t('settings_details:timezone')}</td>
                <td data-cy="timezone">{accountDetails.timezone}</td>
              </tr>
              <tr>
                <td>{t('settings_details:active')}</td>
                <td data-cy="active">
                  <Boolean value={accountDetails.active} />
                </td>
              </tr>
              <tr>
                <td>{t('settings_details:demo')}</td>
                <td data-cy="demo">
                  <Boolean value={accountDetails.demo} />
                </td>
              </tr>
              <tr>
                <td>{t('settings_details:created_at')}</td>
                <td data-cy="created_at">
                  {accountDetails.createdAt && (
                    <Date date={accountDetails.createdAt} />
                  )}
                </td>
              </tr>
              <tr>
                <td>{t('settings_details:deactivated_at')}</td>
                <td>
                  {accountDetails.deactivatedAt && (
                    <Date date={accountDetails.deactivatedAt} />
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <div id="details-grid">
            <PropertyGrid properties={{
              [t('settings_details:name')]: (
                <span data-cy="name">{accountDetails.name}</span>
              ),
              [t('settings_details:country')]: (
                <span data-cy="country">{accountDetails.country}</span>
              ),
              [t('settings_details:currency')]: (
                <span data-cy="currency">{accountDetails.currency}</span>
              ),
              [t('settings_details:timezone')]: (
                <span data-cy="timezone">{accountDetails.timezone}</span>
              ),
              [t('settings_details:active')]: (
                <span data-cy="active">{accountDetails.active ? 'True' : 'False'}</span>
              ),
              [t('settings_details:demo')]: (
                <span data-cy="demo">{accountDetails.demo ? 'True' : 'False'}</span>
              ),
              [t('settings_details:created_at')]: (
                <span data-cy="created_at">
                  {accountDetails.createdAt && (
                    <Date date={accountDetails.createdAt} />
                  )}
                </span>
              ),
              [t('settings_details:deactivated_at')]: (
                <span data-cy="deactivated_at">
                  {accountDetails.deactivatedAt && (
                    <Date date={accountDetails.deactivatedAt} />
                  )}
                </span>
              )
            }} />
          </div>
        </>
      )
    }
  }
}

export default DetailsSettings
